const isFailedAPI = (data?: object) =>
	!data || Object.prototype.hasOwnProperty.call(data, 'dehydratedState')
export default isFailedAPI
